import { LICENSE_STATE_ACTIVE } from '@jira/platform__license-state/src/license-state.tsx';
import { useRovoEntitlementResource } from '@atlassian/jira-router-resources-rovo-entitlement/src/services/index.tsx';
import { useLicenseStates } from '@atlassian/jira-tenant-context-controller/src/components/license-states/index.tsx';
import { useApplicationPermissions } from '@atlassian/jira-tenant-context-controller/src/components/application-permissions/index.tsx';
import { useProjectContext } from '@atlassian/jira-providers-project-context/src/index.tsx';
import { useProjectType } from '@atlassian/jira-project-context-service/src/main.tsx';

export const useShouldShowRovoButton = (): boolean => {
	const { data: rovoEntitlementData } = useRovoEntitlementResource();
	const isRovoLLMEnabled = rovoEntitlementData?.isRovoLLMEnabled ?? false;
	const licenseState = useLicenseStates();
	const { hasSoftwareAccess } = useApplicationPermissions();
	const { data: projectContextData } = useProjectContext();
	const projectType = useProjectType(projectContextData?.projectKey ?? '');

	const softwareAccessEnabled = licenseState.software === LICENSE_STATE_ACTIVE && hasSoftwareAccess;

	if (!isRovoLLMEnabled || !softwareAccessEnabled) {
		return false;
	}

	// Exclude service desk, customer service, and product discovery project pages
	if (
		projectType === 'service_desk' ||
		projectType === 'customer_service' ||
		projectType === 'product_discovery'
	) {
		return false;
	}

	return true;
};
